import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { ShareAltOutlined, CloseOutlined, PlusSquareOutlined } from '@ant-design/icons';
import AnalyticsHelper from '../../helpers/analytics';
import './index.less';

const STORAGE_KEY = 'pwa_install_dismissed';

function isIOS() {
	return /iphone|ipad|ipod/i.test(navigator.userAgent);
}

function isInStandaloneMode() {
	return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
}

const InstallPrompt = () => {
	const [deferredPrompt, setDeferredPrompt] = useState(null);
	const [showAndroid, setShowAndroid] = useState(false);
	const [showIOS, setShowIOS] = useState(false);

	useEffect(() => {
		if (localStorage.getItem(STORAGE_KEY) || isInStandaloneMode()) return;

		if (isIOS()) {
			setShowIOS(true);
			return;
		}

		const handler = (e) => {
			e.preventDefault();
			setDeferredPrompt(e);
			setShowAndroid(true);
		};
		window.addEventListener('beforeinstallprompt', handler);
		return () => window.removeEventListener('beforeinstallprompt', handler);
	}, []);

	const handleDismiss = () => {
		AnalyticsHelper.track('pwa_install', {
			outcome: 'banner_dismissed',
			platform: isIOS() ? 'ios' : 'android'
		});
		localStorage.setItem(STORAGE_KEY, '1');
		setShowAndroid(false);
		setShowIOS(false);
		setDeferredPrompt(null);
	};

	const handleInstall = async () => {
		if (!deferredPrompt) return;
		deferredPrompt.prompt();
		const { outcome } = await deferredPrompt.userChoice;
		AnalyticsHelper.track('pwa_install', { outcome, platform: 'android' });
		if (outcome === 'accepted' || outcome === 'dismissed') {
			localStorage.setItem(STORAGE_KEY, '1');
			setShowAndroid(false);
			setDeferredPrompt(null);
		}
	};

	if (showAndroid) {
		return (
			<div className="install-prompt install-prompt--android">
				<div className="install-prompt__body">
					<PlusSquareOutlined className="install-prompt__icon" />
					<span className="install-prompt__text">Add HKUST ETA to your home screen for quick access</span>
				</div>
				<div className="install-prompt__actions">
					<Button type="primary" size="small" onClick={handleInstall}>
						Install
					</Button>
					<Button type="text" size="small" icon={<CloseOutlined />} onClick={handleDismiss} />
				</div>
			</div>
		);
	}

	if (showIOS) {
		return (
			<div className="install-prompt install-prompt--ios">
				<Button
					type="text"
					size="small"
					icon={<CloseOutlined />}
					className="install-prompt__close"
					onClick={handleDismiss}
				/>
				<div className="install-prompt__ios-body">
					<p className="install-prompt__text">
						Add HKUST ETA to your home screen: tap{' '}
						<ShareAltOutlined className="install-prompt__ios-share" /> then{' '}
						<strong>Add to Home Screen</strong>
					</p>
				</div>
				<div className="install-prompt__ios-arrow" />
			</div>
		);
	}

	return null;
};

export default InstallPrompt;
